<template>
  <div>
    <section>
      <div class="inner row5">
        <div class="title">
          <h1>제품 등록</h1>
        </div>
        <section>
          <div class="row4">
            <article class="flex flexAlignS productStep1">
              <div class="left">
                <div class="title">
                  <h5>제품 산업 분류(1차)<span class="txtRed">*</span></h5>
                </div>
                <div class="content">
                  <table>
                    <tbody>
                      <tr v-for="(item, index) in industryList" :key="index">
                        <th>
                          <input
                            type="checkbox"
                            v-bind:id="'industryCheckbox' + index"
                            v-bind:value="item.IDX"
                            name="industryCheckbox"
                            v-model="selectedIndustryList"
                          />
                        </th>
                        <td>
                          <label v-bind:for="'industryCheckbox' + index">{{
                            item.NAME
                          }}</label>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="right">
                <div class="title">
                  <h5>제품 종류(2차)<span class="txtRed">*</span></h5>
                </div>
                <div class="content">
                  <table>
                    <tbody>
                      <tr
                        v-for="(item, index) in categoryNameList"
                        :key="index"
                      >
                        <th>
                          <input
                            type="checkbox"
                            v-bind:id="'categoryNameCheckbox' + index"
                            v-bind:value="item"
                            name="categoryCheckbox"
                            v-model="selectedCategoryNameList"
                          />
                        </th>
                        <td>
                          <label v-bind:for="'categoryNameCheckbox' + index">{{
                            item
                          }}</label>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </article>

            <article class="productStep2">
              <div class="title">
                <h5>선택된 제품 분류</h5>
              </div>
              <div class="tableContainer">
                <div class="sampleTemplate">
                  <b-table
                    id="table"
                    :fields="fields"
                    :items="saveData.categoryList"
                    hover
                  >
                    <template #cell(INDEX)="data">
                      {{ data.index + 1 }}
                    </template>
                  </b-table>
                </div>
              </div>
            </article>

            <article class="productStep3">
              <div class="container">
                <div class="enrollItem">
                  <div class="title">
                    <h5>제조구분<span class="txtRed">*</span></h5>
                  </div>
                  <div class="productInputBox">
                    <div class="radioContentBox">
                      <div class="radioItem">
                        <input
                          type="radio"
                          id="placeSelector1"
                          name="placeSelector"
                          value="DOMESTIC"
                          v-model="saveData.manufacture"
                          checked
                        />
                        <label for="placeSelector1">국내</label>
                      </div>
                      <div class="radioItem">
                        <input
                          type="radio"
                          id="placeSelector2"
                          name="placeSelector"
                          value="OVERSEAS"
                          v-model="saveData.manufacture"
                        />
                        <label for="placeSelector2">해외</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="enrollItem">
                  <div class="title">
                    <h5>이미지 등록<span class="txtRed">*</span></h5>
                  </div>
                  <div class="productInputBox">
                    <div class="fileUpLoadBox">
                      <input
                        type="text"
                        class="fileUploadName"
                        v-model="selectedFileNames"
                        value="파일선택"
                        disabled
                      />
                      <label
                        for="fileUpload"
                        class="fileUploadBtn"
                        @click="fileUploadBtn()"
                        >업로드</label
                      >
                      <ModalFileUpload
                        v-if="isShowModalFileUpload"
                        v-bind:saveData="saveData"
                        @set-file="setFile"
                        @modal-closed="handleModalClosed"
                      />
                    </div>
                  </div>
                </div>
                <div class="enrollItem">
                  <div class="title">
                    <h5>제품명<span class="txtRed">*</span></h5>
                  </div>
                  <div class="productInputBox">
                    <input type="text" v-model="saveData.name" maxlength="40" />
                  </div>
                </div>
                <div class="enrollItem">
                  <div class="title">
                    <h5>업체명<span class="txtRed">*</span></h5>
                  </div>
                  <div class="productInputBox">
                    <input
                      type="text"
                      v-model="saveData.company"
                      maxlength="40"
                    />
                  </div>
                </div>
                <div class="enrollItem">
                  <div class="title">
                    <h5>가격<span class="txtRed">*</span></h5>
                  </div>
                  <div class="productInputBox">
                    <input
                      type="text"
                      v-model="saveData.price"
                      @keypress="eventUtil.onKeyPressForOnlyDigit($event)"
                      maxlength="10"
                    />
                  </div>
                </div>
                <div class="enrollItem">
                  <div class="title">
                    <h5>홈페이지</h5>
                  </div>
                  <div class="productInputBox">
                    <input
                      type="text"
                      v-model="saveData.homepage"
                      maxlength="85"
                    />
                  </div>
                </div>

                <!-- 추가 항목 -->
                <div class="addItemInputWrapper">
                  <div
                    class="enrollItem"
                    style="margin-bottom:15px;"
                    v-for="(item, index) in additionalItemList"
                    :key="index"
                    v-show="item.NAME != ''"
                  >
                    <div class="title">
                      <h5>{{ item.NAME }}</h5>
                    </div>
                    <div class="productInputBox">
                      <input
                        type="text"
                        v-model="saveData.additionalItemDataList[item.ORDER]"
                        maxlength="40"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </article>

            <article class="productStep4">
              <div class="container">
                <div class="explainBox">
                  <div class="title">
                    <h5>제품 설명<span class="txtRed">*</span></h5>
                  </div>
                  <div class="textAreaBox">
                    <textarea v-model="saveData.desc"></textarea>
                  </div>
                </div>

                <div class="editBox">
                  <div class="title">
                    <h5>상세 설명<span class="txtRed">*</span></h5>
                  </div>
                  <div class="editArea editArea-reply">
                    <vue-editor
                      useCustomImageHandler
                      @image-added="handleImageAdded"
                      v-model="saveData.detail"
                    />
                  </div>
                </div>

                <div class="explainBox mt-4">
                  <div class="title">
                    <h5>거절사유</h5>
                  </div>
                  <div class="textAreaBox">
                    <textarea v-model="saveData.desc"></textarea>
                  </div>
                </div>

                <div class="inputBox">
                  <label class="inputBox__label">댓글</label>
                  <table class="table tableForm tableForm--reson">
                    <tbody>
                      <tr>
                        <td>어떠한 이유로 거절이 되었나요?</td>
                        <td class="alignR">
                          <span class="fs14">수정</span>
                          <span class="fs14 ml-5">수정</span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <i class="ic ic--turn-down-right"></i>
                          해당 사유로 거절되었습니다.
                        </td>
                        <td class="alignR">
                          <span class="fs16 cl-gray9">2022.08.11 12:34:56</span>
                          <span class="fs14 ml-5">답글 달기</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </article>

            <div class="botArea">
              <button class="enrollBtn" @click="onClickSave">수 정</button>
            </div>
          </div>
        </section>
      </div>
    </section>
  </div>
</template>

<script>
import * as eventUtil from "@/utils/eventUtil";
import { mapActions } from "vuex";
import { VueEditor } from "vue2-editor";
import ModalFileUpload from "@/components/managementPopup/ModalFileUpload";
import * as htmlUtil from "@/utils/htmlUtil";

export default {
  name: "ProductManagementDetail",
  components: {
    VueEditor,
    ModalFileUpload,
  },
  data() {
    return {
      eventUtil: eventUtil,
      fields: [
        {
          key: "INDEX",
          label: "No",
          sortable: false,
          sortDirection: "desc",
          class: "text-center",
        },
        {
          key: "IN_OUT",
          label: "실내외",
          sortable: false,
          isActive: true,
          class: "statusOn text-center",
        },
        {
          key: "PLACE",
          label: "장소",
          sortable: false,
          class: "text-center",
        },
        {
          key: "INDUSTRY",
          label: "제품 산업 분류(1차)",
          sortable: false,
          class: "text-center",
        },
        {
          key: "NAME",
          label: "제품 종류(2차)",
          sortable: false,
          class: "text-center",
        },
      ],
      industryList: [],
      selectedIndustryList: [],

      categoryNameList: [],
      selectedCategoryNameList: [],

      additionalItemList: [],

      saveData: {
        idx: "",
        categoryList: [], // 카테고리 목록
        manufacture: "DOMESTIC", // 제조구분
        file0: null, // 대표 이미지
        file1: null, // 추가 이미지1
        file2: null, // 추가 이미지2
        file3: null, // 추가 이미지3
        file4: null, // 추가 이미지4
        file5: null, // 추가 이미지5
        saveFileName0: "",
        saveFileName1: "",
        saveFileName2: "",
        saveFileName3: "",
        saveFileName4: "",
        saveFileName5: "",
        name: "", // 제품명
        company: "", // 업체명
        price: "", // 가격
        homepage: "", // 홈페이지
        desc: "", // 제품설명
        detail: "", // 상세설명
        additionalItemDataList: Array(10), // 추가항목 데이터
        deleteFileList: [], // 삭제파일리스트
      },

      isShowModalFileUpload: false,
    };
  },
  watch: {
    selectedIndustryList(value) {
      this.categoryNameList = [];

      if (value.length <= 0) {
        this.selectedCategoryNameList = [];
        return;
      }

      this.requestCategoryNameByIndustryIdxList(value)
        .then((response) => {
          this.categoryNameList = response.data;
          for (var i = 0; i < this.selectedCategoryNameList.length; i++) {
            if (
              !this.categoryNameList.includes(this.selectedCategoryNameList[i])
            ) {
              this.selectedCategoryNameList.splice(i, 1);
            }
          }
        })
        .catch(() => {
          this.$alert("알림", "데이터를 가져올 수 없습니다.");
        });
    },
    selectedCategoryNameList(value) {
      this.saveData.categoryList = [];

      if (value.length <= 0) {
        return;
      }

      this.requestCategoryByNameAndIndustryIdxList({
        type: "PRODUCT",
        nameList: value,
        industryIdxList: this.selectedIndustryList,
      })
        .then((response) => {
          this.saveData.categoryList = response.data;
        })
        .catch(() => {
          this.$alert("알림", "데이터를 가져올 수 없습니다.");
        });
    },
  },
  computed: {
    selectedFileNames() {
      var file0 = this.saveData.file0;
      var file1 = this.saveData.file1;
      var file2 = this.saveData.file2;
      var file3 = this.saveData.file3;
      var file4 = this.saveData.file4;
      var file5 = this.saveData.file5;

      var fileNames = "";
      if (file0) {
        fileNames += file0.name + ",";
      } else if (
        this.saveData.saveFileName0 &&
        this.saveData.deleteFileList.indexOf(0) < 0
      ) {
        fileNames += this.saveData.saveFileName0 + ",";
      }

      if (file1) {
        fileNames += file1.name + ",";
      } else if (
        this.saveData.saveFileName1 &&
        this.saveData.deleteFileList.indexOf(1) < 0
      ) {
        fileNames += this.saveData.saveFileName1 + ",";
      }

      if (file2) {
        fileNames += file2.name + ",";
      } else if (
        this.saveData.saveFileName2 &&
        this.saveData.deleteFileList.indexOf(2) < 0
      ) {
        fileNames += this.saveData.saveFileName2 + ",";
      }

      if (file3) {
        fileNames += file3.name + ",";
      } else if (
        this.saveData.saveFileName3 &&
        this.saveData.deleteFileList.indexOf(3) < 0
      ) {
        fileNames += this.saveData.saveFileName3 + ",";
      }

      if (file4) {
        fileNames += file4.name + ",";
      } else if (
        this.saveData.saveFileName4 &&
        this.saveData.deleteFileList.indexOf(4) < 0
      ) {
        fileNames += this.saveData.saveFileName4 + ",";
      }

      if (file5) {
        fileNames += file5.name + ",";
      } else if (
        this.saveData.saveFileName5 &&
        this.saveData.deleteFileList.indexOf(5) < 0
      ) {
        fileNames += this.saveData.saveFileName5 + ",";
      }

      if (fileNames == "") {
        return "파일 선택";
      }

      return fileNames;
    },
  },
  mounted() {
    this.requestIndustryList("PRODUCT")
      .then((response) => {
        this.industryList = response.data;
      })
      .catch(() => {
        this.$alert("알림", "데이터를 가져올 수 없습니다.");
      });

    this.requestList("PRODUCT")
      .then((response) => {
        this.additionalItemList = response.data;
      })
      .catch(() => {
        this.$alert("알림", "데이터를 가져올 수 없습니다.");
      });

    var idx = this.$route.params.idx;
    if (idx) {
      this.requestCorpProductDetail(idx)
        .then((response) => {
          let getCategoryNameList = [];
          let getCategoryIdxList = [];
          let getCategoryList = response.data.selectedCategoryList;
          for (let i = 0; i < getCategoryList.length; i++) {
            getCategoryNameList.push(getCategoryList[i].NAME);
            getCategoryIdxList.push(getCategoryList[i].IDX);
          }
          this.selectedCategoryNameList = getCategoryNameList;
          this.saveData.categoryList = getCategoryIdxList;

          this.selectedIndustryList = response.data.selectedIndustryList;

          let product = response.data.product;
          this.saveData.idx = product.IDX;
          this.saveData.manufacture = product.MANUFACTURE;
          this.saveData.name = product.NAME;
          this.saveData.company = product.COMPANY;
          this.saveData.price = product.PRICE;
          this.saveData.homepage = product.HOMEPAGE;
          this.saveData.desc = product.DESC;
          /* this.saveData.detail = product.DETAIL; */
          this.saveData.detail = htmlUtil.stringToTag(product.DETAIL);
          this.saveData.additionalItemDataList =
            response.data.additionalItemDataList;

          if (product.FILE_REAL_NAME_0)
            this.saveData.saveFileName0 = product.FILE_REAL_NAME_0;
          if (product.FILE_REAL_NAME_1)
            this.saveData.saveFileName1 = product.FILE_REAL_NAME_1;
          if (product.FILE_REAL_NAME_2)
            this.saveData.saveFileName2 = product.FILE_REAL_NAME_2;
          if (product.FILE_REAL_NAME_3)
            this.saveData.saveFileName3 = product.FILE_REAL_NAME_3;
          if (product.FILE_REAL_NAME_4)
            this.saveData.saveFileName4 = product.FILE_REAL_NAME_4;
          if (product.FILE_REAL_NAME_5)
            this.saveData.saveFileName5 = product.FILE_REAL_NAME_5;
        })
        .catch(() => {
          this.$alert("알림", "데이터를 가져올 수 없습니다.");
        });
    }
  },
  methods: {
    ...mapActions("category", [
      "requestIndustryList",
      "requestCategoryNameByIndustryIdxList",
      "requestCategoryByNameAndIndustryIdxList",
    ]),
    ...mapActions("additionalItem", ["requestList"]),
    ...mapActions("editor", ["addImage"]),
    ...mapActions("product", ["saveProduct", "requestCorpProductDetail"]),
    goback() {
      this.$router.go(-1);
    },
    writeBtn() {
      this.$router.push("/admin/noticeManagementWrite");
    },
    onClickSave() {
      if (this.saveData.categoryList.length === 0) {
        this.$alert("알림", "카테고리를 선택해주세요.");
        return;
      }
      if (this.saveData.manufacture === "") {
        this.$alert("알림", "제조구분을 선택해주세요.");
        return;
      }
      if (this.saveData.file0 === null && this.saveData.saveFileName0 === "") {
        this.$alert("알림", "대표 이미지를 등록해주세요.");
        return;
      }
      if (this.saveData.name === "") {
        this.$alert("알림", "제품명을 입력해주세요.");
        return;
      }
      if (this.saveData.company === "") {
        this.$alert("알림", "업체명을 입력해주세요.");
        return;
      }
      if (this.saveData.price === "") {
        this.$alert("알림", "가격을 입력해주세요.");
        return;
      }
      if (this.saveData.desc === "") {
        this.$alert("알림", "제품설명을 선택해주세요.");
        return;
      }
      if (this.saveData.detail === "") {
        this.$alert("알림", "상세설명을 입력해주세요.");
        return;
      }

      this.saveProduct(this.saveData)
        .then((response) => {
          if (response.status === 200) {
            this.$alert(
              "알림",
              "등록되었습니다. 등록하신 제품은 관리자의 승인 후 노출됩니다.",
              "확인",
              {
                closed: () => {
                  this.$router.push({ path: "/corp/corpProductManagement" });
                },
              }
            );
          } else {
            this.$alert("알림", "제품 등록을 실패했습니다.");
          }
        })
        .catch(() => {
          this.$alert("알림", "서버와 통신을 실패했습니다.");
        });
    },
    handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      var formData = new FormData();
      formData.append("image", file);

      this.addImage(formData)
        .then((response) => {
          Editor.insertEmbed(cursorLocation, "image", response.data.URL);
          resetUploader();
        })
        .catch(() => {
          this.$alert("알림", "이미지를 업로드할 수 없습니다.");
        });
    },
    fileUploadBtn() {
      this.isShowModalFileUpload = true;
    },
    handleModalClosed(value, param) {
      if (value === ModalFileUpload.name) {
        this.isShowModalFileUpload = false;

        if (param.result == true) {
          this.$refs.table.refresh();
        }
      }
    },
    setFile(file0, file1, file2, file3, file4, file5) {
      this.saveData.file0 = file0;
      this.saveData.file1 = file1;
      this.saveData.file2 = file2;
      this.saveData.file3 = file3;
      this.saveData.file4 = file4;
      this.saveData.file5 = file5;
    },
  },
};
</script>

<style scoped lang="scss">
.sampleTemplate ::v-deep {
  @import "~bootstrap/dist/css/bootstrap.min";
}
</style>
